

const state = {
    globalRequestParams: {}, // 全局搜索条件
    openImport: false
};

const mutations = {
 ['OPEN_IMPORT'](state,openImport){
     state.openImport = openImport
 }
};

const actions = {

};

export default {
    namespaced: true,
    state,
    mutations,
    actions
}
